export const SUPPLIER = 'SUPPLIER';
export const RETAILER = 'RETAILER';
